import { Badge } from 'app/components/ui/badge'
import type { FormVersions } from 'app/lib/forms/builder'

type VersionRow = { formId: string; formVersion: number; status: string }

/** Live is what a packet sends today. A newer draft is shown beside it, never instead of it. */
export function FormStatusBadge({ entry }: { entry: FormVersions<VersionRow> }) {
  const { latest, published } = entry
  const hasNewerDraft = latest.status !== `published`
  return (
    <span className="flex flex-wrap items-center gap-1.5">
      {published && <Badge color="green" label={`Live v${published.formVersion}`} />}
      {hasNewerDraft && <Badge color="gray" label={published ? `Draft v${latest.formVersion}` : `Draft`} />}
    </span>
  )
}
